import {SSOSettingModel} from "../../model/SSOSetting";

export const urls = {
  home: "/settings/",
  list: "/settings/sso-setting",
}

export const ListBreadcrumb = [
  {
    label: "Settings",
    url: urls.home
  },
  {
    label: "SSO Setting",
    url: "#"
  }
];


export const EditBreadcrumb = [
  {
    label: "Settings",
    url: urls.home
  },
  {
    label: "SSO Setting",
    url: urls.list
  },
  {
    label: "Edit",
    url: '#'
  }
];

export interface IState {
  id: number,
  ssoSetting: SSOSettingModel
}